import React from 'react';
import OddWithDesc from '../../common/OddWithDesc';
import { classIf } from '../../data/utils';
import Link from '../../router/Link';
import { getEventUrl } from '../../prematch/Prematch';
import { getScores } from '../scores/scores';
import Img from '../../common/Img';

export default function EventPreview(props) {
    const event = props.data;
    const bet = event.bets[0];
    const [header, scoresTeam1, scoresTeam2] = getScores(event.score, 'c_32_2_2_1', 'c_32_3_2_1');
    const service = event.score?.srv ?? 0;

    return (
        <Link href={getEventUrl(event)} replace={props.replace} className={"c_32" + classIf(props.active, 'active')} useDiv={props.linksAreDivs} data-type={props.type} data-live>
            {props.showFullDesc &&
                <div className="c_32_1">
                    <div className="c_32_1_1">{event.tournamentDesc}</div>
                </div>
            }
            <div className="c_32_2">
                <div className="c_32_2_1">{event.score?.periodo} {event.score?.currentMinute}</div>
                <div className="c_32_2_2">{header}</div>
            </div>
            <div className="c_32_3">
                <div className="c_32_3_1">
                    {service !== 0 &&
                        <div className={"c_32_3_1_1" + classIf(service === 1, 'active')} />
                    }
                    <div className="c_32_3_1_2">{event.team1}</div>
                </div>
                <div className="c_32_3_2">
                    {scoresTeam1}
                </div>
            </div>
            <div className="c_32_3">
                <div className="c_32_3_1">
                    {service !== 0 &&
                        <div className={"c_32_3_1_1" + classIf(service === 2, 'active')} />
                    }
                    <div className="c_32_3_1_2">{event.team2}</div>
                </div>
                <div className="c_32_3_2">
                    {scoresTeam2}
                </div>
            </div>
            <div className="c_32_4">
                <div className="c_32_4_1">
                    {bet.desc}
                </div>
            </div>
            <div className="c_32_5">
                <div className="c_32_5_1">
                    {bet.odds.map(o =>
                        <OddWithDesc key={o.uniqueId} data={o} />
                    )}
                </div>
                <div className="c_32_5_2">
                    <span className="c_32_5_2_1">+{event.plus}</span>
                    <Img className="c_32_5_2_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" />
                </div>
            </div>
        </Link>
    );
}
